import { useTranslation } from 'react-i18next';

import { Box, FlexBox } from '@sternum/styled-system';
import { Tooltip } from '@sternum/ui';
import { routes } from '@sternum/web/config/routes';
import { useGeneratePathWithCurrentClient, useMe } from '@sternum/web/features/auth/hooks';
import { useFavouriteClients } from '@sternum/web/features/client/hooks';
import { namespaces } from '@sternum/web/services/i18n';

import { WorkspacesSearch } from './WorkspacesSearch.component';

import { LinkStyled, MenuItem } from '../UserPopup.styles';
import { AvatarStyled } from './WorkspacesSection.styles';

export function WorkspacesSection() {
  const { t } = useTranslation(namespaces.appContainerWithMenu);
  const generatePath = useGeneratePathWithCurrentClient();
  const { currentClient } = useMe();
  const { clients: favouriteClients } = useFavouriteClients();

  const favouriteClientsToShow = favouriteClients.slice(-2);

  return (
    <MenuItem $active>
      <Box w="100%">
        <FlexBox w="100%" justifyContent="space-between" alignItems="center">
          <LinkStyled style={{ width: 'auto' }} to={generatePath(routes.clients.absolute)}>
            {t('workspaces')}
          </LinkStyled>

          <FlexBox>
            {favouriteClientsToShow.map((favouriteClient) => (
              <Tooltip key={favouriteClient.id} title={favouriteClient.client.name}>
                <AvatarStyled
                  role="presentation"
                  aria-label={`${favouriteClient.client.name} last client avatar`}
                  size={28}
                  style={{ marginLeft: -10 }}
                >
                  {favouriteClient.client.name[0]}
                </AvatarStyled>
              </Tooltip>
            ))}

            <Tooltip title={currentClient?.name}>
              <AvatarStyled
                role="presentation"
                aria-label={`${currentClient?.name} selected client avatar`}
                $selected
                size={28}
                style={{ marginLeft: 8 }}
              >
                {currentClient?.name?.[0] || '?'}
              </AvatarStyled>
            </Tooltip>
          </FlexBox>
        </FlexBox>

        <Box mt={8}>
          <WorkspacesSearch />
        </Box>
      </Box>
    </MenuItem>
  );
}
